import { z } from 'zod';

/**
 * Validate node props against schema
 */
export function validateNodeProps<T>(schema: z.ZodType<T>, props: unknown): { success: true; data: T } | { success: false; errors: z.ZodError } {
  const result = schema.safeParse(props);
  if (result.success) {
    return { success: true, data: result.data };
  } else {
    return { success: false, errors: result.error };
  }
}

/**
 * Validate edge props against schema
 */
export function validateEdgeProps<T>(schema: z.ZodType<T>, props: unknown): { success: true; data: T } | { success: false; errors: z.ZodError } {
  const result = schema.safeParse(props);
  if (result.success) {
    return { success: true, data: result.data };
  } else {
    return { success: false, errors: result.error };
  }
}

/**
 * Get validation errors as human-readable strings
 */
export function formatValidationErrors(error: z.ZodError): string[] {
  return error.errors.map((err) => {
    const path = err.path.join('.');
    return `${path}: ${err.message}`;
  });
}
